// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","actionBlack":"#2e2e2e","customWhite":"#ffffff","customWhiteDk":"#fafafa","customGreyLt":"#f2f2f2","borderGrey2":"#e2e2e2","customGreyFaded":"#f7f9fc","footerGrey":"#c0c0c0","container":"hmjWDer1xm6TBZIegn1ky","pressed":"_3dFQmwg0vuqaogtF0NFcNp","disabled":"_2ChYMiVfaDRhBXkvs6Uf_g"};


//////////////////
// WEBPACK FOOTER
// ./src/common/simple-large-button/SimpleLargeButton.css
// module id = 1033
// module chunks = 1